import { Drawer } from 'antd';
import clsx from 'clsx';
import React from 'react';

export interface SidePanelProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  className?: string;
  width?: number;
  closable?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({
  open,
  onClose,
  title,
  children,
  width = 560,
  className,
  closable = true,
}) => {
  return (
    <Drawer
      title={title}
      placement="right"
      open={open}
      onClose={onClose}
      width={width}
      className={className}
      closable={closable}
      destroyOnClose
    >
      {children}
    </Drawer>
  );
};

/**
 * SidePanel component with a white header and black title text.
 *
 * @param props - SidePanelProps for configuring the side panel.
 * @returns A side panel with white header styling.
 */
export function WhiteSidePanel(props: SidePanelProps) {
  return (
    <SidePanel
      {...props}
      className={clsx(
        props.className,
        '[&_.ant-drawer-header]:!bg-white [&_.ant-drawer-header_*]:text-black [&_.ant-drawer-title]:font-normal',
      )}
    />
  );
}

export default SidePanel;
